export enum LegendTab {
  None,
  QHChiTiet = 'quyHoachChiTiet',
  QHPhanKhu = 'quyHoachPhanKhu',
  TaiNguyenMoiTruong = 'taiNguyenMoiTruong',
}

export interface Legend {
  label: string;
  url: string;
  imageData: string;
  contentType: string;
  height: number;
  width: number;
}
